import { type BoxProps } from '@mui/material/Box';
import { ImgHTMLAttributes, forwardRef, SyntheticEvent, useEffect, useState } from 'react';

import BoxWrapper from '../../wrappers/BoxWrapper';

export type IAtomImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  fallbackSrc?: string;
  sx?: BoxProps['sx'];
};

const AtomImage = forwardRef<HTMLImageElement, IAtomImageProps>(
  (
    {
      alt,
      src,
      fallbackSrc,
      sx,
      loading = 'lazy',
      decoding = 'async',
      referrerPolicy = 'no-referrer',
      onError,
      ...props
    },
    ref,
  ) => {
    const [imgSrc, setImgSrc] = useState(src);

    const handleError = (e: SyntheticEvent<HTMLImageElement, Event>): void => {
      if (fallbackSrc && imgSrc !== fallbackSrc) {
        setImgSrc(fallbackSrc);
      }
      onError?.(e);
    };

    useEffect(() => {
      setImgSrc(src);
    }, [src]);

    return (
      <BoxWrapper
        component="img"
        ref={ref}
        src={imgSrc}
        alt={alt}
        loading={loading}
        decoding={decoding}
        referrerPolicy={referrerPolicy}
        onError={handleError}
        sx={sx}
        {...props}
      />
    );
  },
);

AtomImage.displayName = 'AtomImage';

export default AtomImage;
